import Slider, { SliderPosition } from "./Slider";

export { Slider as default, SliderPosition };
